import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap pt-3 p-8 pb-0" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex flex-wrap" }
const _hoisted_4 = { class: "stamp-container" }
const _hoisted_5 = { class: "stamp-header" }
const _hoisted_6 = { class: "stamp-header__desc" }
const _hoisted_7 = { class: "stamp-box" }
const _hoisted_8 = { class: "target-date" }
const _hoisted_9 = { class: "target-date__desc" }
const _hoisted_10 = { class: "target-date__time" }
const _hoisted_11 = { class: "work-place" }
const _hoisted_12 = { class: "work-place__desc" }
const _hoisted_13 = { class: "flex justify-center" }
const _hoisted_14 = { class: "flex justify-center" }
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = { class: "flex justify-center" }
const _hoisted_17 = { class: "flex justify-center" }
const _hoisted_18 = { class: "flex justify-center" }
const _hoisted_19 = { class: "flex justify-center" }
const _hoisted_20 = { class: "flex justify-center" }
const _hoisted_21 = { class: "stamp-editing" }
const _hoisted_22 = { class: "stamp-editing__desc" }
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "mr-1" }
const _hoisted_26 = { class: "ml-1" }
const _hoisted_27 = { class: "w-40" }
const _hoisted_28 = { class: "flex justify-center flex-col" }
const _hoisted_29 = { class: "flex justify-center" }
const _hoisted_30 = { class: "flex justify-center mt-2" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "ー", -1)
const _hoisted_32 = { class: "stamp-editing__button" }
const _hoisted_33 = { class: "flex mr-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M13 12H18.5C18.7761 12 19 12.2239 19 12.5C19 12.7761 18.7761 13 18.5 13H13V18.5C13 18.7761 12.7761 19 12.5 19C12.2239 19 12 18.7761 12 18.5V13H6.5C6.22386 13 6 12.7761 6 12.5C6 12.2239 6.22386 12 6.5 12H12V6.5C12 6.22386 12.2239 6 12.5 6C12.7761 6 13 6.22386 13 6.5V12Z",
    fill: "#007bc3"
  })
], -1)
const _hoisted_35 = { class: "stamp-button flex justify-center mt-8 flex-col" }
const _hoisted_36 = { class: "button-apply" }
const _hoisted_37 = { class: "button-cancel" }
const _hoisted_38 = { class: "approval-route" }
const _hoisted_39 = { class: "approval-route__desc" }
const _hoisted_40 = { class: "approval-route__table flex justify-between" }
const _hoisted_41 = { class: "flex justify-center" }
const _hoisted_42 = { class: "flex lg:justify-around" }
const _hoisted_43 = { class: "flex justify-center" }
const _hoisted_44 = { class: "approval-route__table" }
const _hoisted_45 = { class: "flex justify-center" }
const _hoisted_46 = { class: "flex lg:justify-around" }
const _hoisted_47 = { class: "flex justify-center" }
const _hoisted_48 = { class: "flex justify-center" }
const _hoisted_49 = { class: "flex justify-center" }
const _hoisted_50 = { class: "flex justify-center" }
const _hoisted_51 = { class: "flex justify-center" }
const _hoisted_52 = { class: "approval-route__table flex justify-between" }
const _hoisted_53 = { class: "flex justify-center" }
const _hoisted_54 = { class: "flex lg:justify-around" }
const _hoisted_55 = { class: "flex justify-center" }
const _hoisted_56 = { class: "approval-route__table" }
const _hoisted_57 = { class: "flex justify-center" }
const _hoisted_58 = { class: "flex lg:justify-around" }
const _hoisted_59 = { class: "flex justify-center" }
const _hoisted_60 = { class: "flex justify-center" }
const _hoisted_61 = { class: "flex justify-center" }
const _hoisted_62 = { class: "flex justify-center" }
const _hoisted_63 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")
  const _component_Select = _resolveComponent("Select")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Input = _resolveComponent("Input")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_ButtonGreenGradation = _resolveComponent("ButtonGreenGradation")
  const _component_MainLayoutContentMedium = _resolveComponent("MainLayoutContentMedium")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_MainLayoutContentMedium, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('stampRegister.application')), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("p", _hoisted_9, _toDisplayString(_ctx.t('stampRegister.targetDate')), 1),
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('stampRegister.dateExample')), 1)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("p", _hoisted_12, _toDisplayString(_ctx.t('overtimeRegister.stampingRecord')), 1),
                  _createVNode(_component_Table, {
                    class: "w-full",
                    data: _ctx.optionStampingData,
                    headers: _ctx.optionStampingHeader
                  }, {
                    check_in: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", null, _toDisplayString(item.check_in), 1)
                      ])
                    ]),
                    leaving_work: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", null, _toDisplayString(item.leaving_work), 1)
                      ])
                    ]),
                    break_start: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("div", null, _toDisplayString(item.break_start), 1)
                      ])
                    ]),
                    break_end: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", null, _toDisplayString(item.break_end), 1)
                      ])
                    ]),
                    go_out: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("div", null, _toDisplayString(item.go_out), 1)
                      ])
                    ]),
                    going_back: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("div", null, _toDisplayString(item.going_back), 1)
                      ])
                    ]),
                    work_place: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", null, _toDisplayString(item.work_place), 1)
                      ])
                    ]),
                    attendance_organization: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("div", null, _toDisplayString(item.attendance_organization), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["data", "headers"])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("p", _hoisted_22, _toDisplayString(_ctx.t('stampRegister.application')), 1),
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_Table, {
                      class: "w-full",
                      headers: _ctx.stampRegisterHeader,
                      data: _ctx.paramsAddStampRegister.stamp_register_details
                    }, {
                      stamp_type: _withCtx(({ item }) => [
                        _createVNode("div", null, _toDisplayString(item), 1)
                      ]),
                      body: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paramsAddStampRegister.stamp_register_details, (item, index) => {
                          return (_openBlock(), _createBlock("tr", {
                            key: item.index
                          }, [
                            _createVNode("td", null, [
                              _createVNode(_component_Select, {
                                class: "text-center",
                                "options-select": _ctx.stampTypeOption,
                                "item-value": "value",
                                "item-text": "text",
                                placeholder: _ctx.t('checkIn')
                              }, null, 8, ["options-select", "placeholder"])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_24, [
                                _createVNode("div", _hoisted_25, [
                                  _createVNode(_component_DatePicker, {
                                    width: "120",
                                    "is-icon-chevron-left": "",
                                    "is-icon-chevron-right": "",
                                    type: "date",
                                    format: "YYYY/MM/DD"
                                  })
                                ]),
                                _createVNode("div", _hoisted_26, [
                                  _createVNode(_component_Input, {
                                    placeholder: 
                                  _ctx.t('stampRegister.textDateExample')
                                ,
                                    type: "time"
                                  }, null, 8, ["placeholder"])
                                ])
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode(_component_Select, {
                                class: "text-center",
                                "options-select": _ctx.headquarters,
                                "item-value": "value",
                                "item-text": "text",
                                placeholder: 
                              _ctx.t('stampRegister.placeholderTextExample1')
                            
                              }, null, 8, ["options-select", "placeholder"])
                            ]),
                            _createVNode("td", _hoisted_27, [
                              _createVNode("div", _hoisted_28, [
                                _createVNode(_component_RadioGroup, {
                                  "options-radio": _ctx.optionsRadioDefault,
                                  class: "custom-radio"
                                }, null, 8, ["options-radio"])
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_29, [
                                _createVNode(_component_Checkbox, {
                                  modelValue: 
                                _ctx.paramsAddStampRegister.stamp_register_details[
                                  index
                                ].stamp_register_end
                              ,
                                  "onUpdate:modelValue": ($event: any) => (
                                _ctx.paramsAddStampRegister.stamp_register_details[
                                  index
                                ].stamp_register_end
                               = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode(_component_Input, {
                                placeholder: 
                              _ctx.t('stampRegister.placeholderTextExample')
                            ,
                                type: "text",
                                max: 59,
                                min: 0
                              }, null, 8, ["placeholder"])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_30, [
                                _createVNode("span", {
                                  class: "flex action--add custom-delete",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteStampEditing && _ctx.deleteStampEditing(...args)))
                                }, [
                                  _hoisted_31
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["headers", "data"]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode(_component_Button, { onClick: _ctx.addStampEditing }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_33, [
                            _hoisted_34,
                            _createTextVNode(" " + _toDisplayString(_ctx.t('addAction')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode("button", _hoisted_36, _toDisplayString(_ctx.t('stampRegister.buttonApply')), 1),
                _createVNode("button", _hoisted_37, _toDisplayString(_ctx.t('stampRegister.buttonCancel')), 1)
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode("p", _hoisted_39, _toDisplayString(_ctx.t('stampRegister.approvalRoute')), 1),
                _createVNode("div", _hoisted_40, [
                  _createVNode(_component_Table, {
                    "custom-size": true,
                    headers: _ctx.optionApprovalHeader,
                    data: _ctx.approvalRouteData,
                    class: "w-3/4"
                  }, {
                    target_date: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_41, _toDisplayString(item.target_date), 1)
                    ]),
                    application_time: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_42, [
                        _createVNode("span", null, _toDisplayString(_ctx.t('overtimeRegister.attendanceAtWorkLb')), 1),
                        _createVNode("span", null, _toDisplayString(item.application_time), 1)
                      ])
                    ]),
                    organization: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_43, _toDisplayString(item.organization), 1)
                    ]),
                    _: 1
                  }, 8, ["headers", "data"]),
                  _createVNode(_component_ButtonGreenGradation, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('inProgress')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_44, [
                  _createVNode(_component_Table, {
                    headers: _ctx.optionApprovalPrivilegeHeader,
                    data: _ctx.approvalRoutePrivilegeData
                  }, {
                    first_approver: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_45, _toDisplayString(item.first_approver), 1)
                    ]),
                    setter_and_communicator: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_46, [
                        _createVNode("span", null, _toDisplayString(_ctx.t('overtimeRegister.attendanceAtWorkLb')), 1),
                        _createVNode("span", null, _toDisplayString(item.setter_and_communicator), 1)
                      ])
                    ]),
                    organization: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_47, _toDisplayString(item.organization), 1)
                    ]),
                    full_name: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_48, _toDisplayString(item.full_name), 1)
                    ]),
                    status: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_49, _toDisplayString(item.status), 1)
                    ]),
                    approval_date_time: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_50, _toDisplayString(item.approval_date_time), 1)
                    ]),
                    comment: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_51, _toDisplayString(item.comment), 1)
                    ]),
                    _: 1
                  }, 8, ["headers", "data"])
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode(_component_Table, {
                    "custom-size": true,
                    headers: _ctx.optionApprovalHeader,
                    data: _ctx.approvalRouteData,
                    class: "w-3/4"
                  }, {
                    target_date: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_53, _toDisplayString(item.target_date), 1)
                    ]),
                    application_time: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_54, [
                        _createVNode("span", null, _toDisplayString(_ctx.t('overtimeRegister.attendanceAtWorkLb')), 1),
                        _createVNode("span", null, _toDisplayString(item.application_time), 1)
                      ])
                    ]),
                    organization: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_55, _toDisplayString(item.organization), 1)
                    ]),
                    _: 1
                  }, 8, ["headers", "data"]),
                  _createVNode(_component_ButtonGreenGradation, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('inProgress')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_56, [
                  _createVNode(_component_Table, {
                    headers: _ctx.optionApprovalPrivilegeHeader,
                    data: _ctx.approvalRoutePrivilegeData
                  }, {
                    first_approver: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_57, _toDisplayString(item.first_approver), 1)
                    ]),
                    setter_and_communicator: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_58, [
                        _createVNode("span", null, _toDisplayString(_ctx.t('overtimeRegister.attendanceAtWorkLb')), 1),
                        _createVNode("span", null, _toDisplayString(item.setter_and_communicator), 1)
                      ])
                    ]),
                    organization: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_59, _toDisplayString(item.organization), 1)
                    ]),
                    full_name: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_60, _toDisplayString(item.full_name), 1)
                    ]),
                    status: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_61, _toDisplayString(item.status), 1)
                    ]),
                    approval_date_time: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_62, _toDisplayString(item.approval_date_time), 1)
                    ]),
                    comment: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_63, _toDisplayString(item.comment), 1)
                    ]),
                    _: 1
                  }, 8, ["headers", "data"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}